import styled from "styled-components";
import { WINDOW_SIZE } from "../util/Constants";
import { Surface } from "./DashboardPrimitives";

export const ActivityEmpty = styled.div`
  align-items: center;
  color: var(--text-faint, #8a919e);
  display: flex;
  flex: 1 1 auto;
  font-size: 12.5px;
  justify-content: center;
  line-height: 1.5;
  min-height: 0;
  padding: 22px;
  text-align: center;
`

export const ActivitySurface = styled(Surface)`
  align-self: start;
  max-height: 450px;
  min-height: 450px;
  overflow: hidden;
  position: sticky;
  top: 82px;

  @media (max-width: ${WINDOW_SIZE.TABLET}) {
    position: static;
  }
`

export const ActivityList = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--border-strong, #d9dee8);
    border-radius: 999px;
  }
`


export const ActivitySkeletonRow = styled.div`
  padding: 10px 8px;

  & + & {
    border-top: 1px solid var(--hairline-soft, #edf1f7);
  }
`


export const ActivityRowButton = styled.button`
  align-items: center;
  background: var(--surface, #ffffff);
  border: 0;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  display: grid;
  font: inherit;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) auto;
  min-height: 54px;
  padding: 10px 8px;
  text-align: left;
  width: 100%;

  & + & {
    border-top: 1px solid var(--hairline-soft, #edf1f7);
  }

  &:hover {
    background: var(--surface-subtle, #fbfcfe);
  }

  &:focus-visible {
    outline: 2px solid var(--ink, #20242d);
    outline-offset: -2px;
  }
`
